module.exports = __webpack_public_path__ + "static/img/21.dd7d39f6.png";